<template>
    <tr>
        <slot v-if="!row.isComplex" :row="row"/>
        <td :colspan="columns" v-else class="guide-notification-table-expandable">
            <table width="100%" class="table table-hoverable">
                <tr @click="toggleIsExpanded">
                    <td :colspan="columns">
                        <attribute-name :name="row.attribute" />
                        <v-icon icon="caret-right" :class="{'is-rotating-right': isExpanded}"/>
                    </td>
                </tr>
                <template v-for="subRow in row.subValues">
                    <!--It will re-render again and reuse the same slot template-->
                    <column-row :row="subRow" :columns="columns" v-show="isExpanded" :key="subRow.$internalId">
                        <template slot-scope="{row}">
                            <slot :row="row"/>
                        </template>
                    </column-row>
                </template>
            </table>
        </td>
    </tr>
</template>

<script>
    import {vIcon} from '@/components/form';
    import AttributeName from './attribute-name';

    export default {
        name: 'column-row',
        components: {vIcon, AttributeName},
        props: {
            row: Object,
            columns: Number,
        },
        data() {
            return {
                isExpanded: false,
            };
        },
        methods: {
            toggleIsExpanded() {
                this.isExpanded = !this.isExpanded;
            },
        },
    };
</script>
